// src/features/kommunikation/services/NachversandService.ts
//
// Nachversand an Mitarbeiter (02.11.2026). Spricht die Edge Function
// lohnschein-nachversand an: offene Fälle laden und den Nachversand für einen
// Kunden und Monat auslösen. Die Anmeldung läuft wie beim Lohnschein-Versand
// über die Supabase-Session plus das persönliche Identitäts-Token aus dem
// Google-Login (localStorage 'authToken'); die Function ermittelt daraus
// serverseitig, wer den Nachversand auslöst.

import { supabase } from '../../../shared/services/supabase';
import { edgeFunctionFehlertext } from '../../../shared/utils/edgeFunctionFehler';
import { NachversandAuftrag, NachversandErgebnis, NachversandFall } from '../types';

const IDENTITAET_FEHLT = 'Keine Anmelde-Identität gefunden. Bitte im Intranet neu einloggen.';

function identitaetsToken(): string {
  const token = localStorage.getItem('authToken');
  if (!token) throw new Error(IDENTITAET_FEHLT);
  return token;
}

export class NachversandService {
  /** Alle offenen Nachversand-Fälle über alle Kunden. */
  async ladeFaelle(): Promise<NachversandFall[]> {
    const { data, error } = await supabase.functions.invoke('lohnschein-nachversand', {
      body: { mode: 'liste', identity_token: identitaetsToken() }
    });
    if (error) {
      throw new Error(await edgeFunctionFehlertext(error, 'Offene Fälle konnten nicht geladen werden.'));
    }
    return ((data as { faelle?: NachversandFall[] } | null)?.faelle) ?? [];
  }

  /** Nachversand für einen Kunden und Monat an wenige Mitarbeiter. */
  async sende(auftrag: NachversandAuftrag): Promise<NachversandErgebnis> {
    const { data, error } = await supabase.functions.invoke('lohnschein-nachversand', {
      body: {
        mode: 'senden',
        identity_token: identitaetsToken(),
        customer_id: auftrag.customer_id,
        jahr: auftrag.jahr,
        monat: auftrag.monat,
        personalnummern: auftrag.personalnummern
      }
    });
    if (error) {
      throw new Error(await edgeFunctionFehlertext(error, 'Nachversand fehlgeschlagen.'));
    }
    return data as NachversandErgebnis;
  }
}

export const nachversandService = new NachversandService();
